import React from "react";
import { Link } from "react-router-dom";
import { PosterDetail } from "../PosterDetail/PosterDetail";

export const PosterListing = () => {
  return (
    <div>
      <Link to="/poster">Back</Link>
    </div>
  );
};
